import React, { Component ,Fragment } from "react";
import PropTypes from "prop-types";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import { Container, Row, Col,InputGroup, InputGroupAddon, Button, Input, UncontrolledTooltip, FormGroup, Label} from 'reactstrap';
import http from "../../../../services/HttpService";
import {Link} from "react-router-dom";
import Route from "../../../../Routes";
import Loading from "../../../includes/Loading";
import i18next from 'i18next';
import { Translation } from "react-i18next";

import LayoutDashboard from "../../../../views/layout/Dashboard";
import {layout} from "../../../../../ts-helpers/decorators";

@layout(LayoutDashboard)
@(connect((state) => {
    return { };
}) as any)

export default class AllTool extends Component<any> {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    state = {
        tools: [],
        loading: true,
        keyword_value:'',
        tool:true,
    };

    constructor(props: Map<any, any>) {
        super(props);
    }

    componentDidMount() {
        this.getData();
        this.props.onRef(this);
    }

    @autobind
    getData(){
        http.get('/tools/all')
            .then(response => response.json())
            .then((data) => {
                this.setState({
                    tools:data,
                    loading:false,
                });
            });
    }

    @autobind
    handleChangeKeyword(event) {
        const keyword_value = event.target.value;
        this.setState({
            keyword_value,
        });
    }

    @autobind
    search(event) {
        event.preventDefault();

        const {keyword_value} = this.state;

        //console.log("keyword_value",keyword_value);

        http.post(`/tools/admin/search`, {
            keywords:keyword_value
        })
            .then(response => response.json())
            .then((data) => {
                //console.log("data",data);

                if(data.status == 'null'){
                    this.setState({
                        loading: false,
                        updated: false,
                        tool:false
                    });
                }else{
                    this.setState({
                        loading: false,
                        updated: false,
                        tools:data,
                        tool:true
                    });
                }
            });
    }


    @autobind
    changeLanguage(e) {
        const lng = e.currentTarget.dataset.lang
        this.setState({ lng: lng }, () => {
            i18next.changeLanguage(lng);
            this.props.changeLang();
        });
    }

    @autobind
    langTranslation(e){
        return <Translation>{t => t(`${e}`)}</Translation>
    }

    render() {
        const {loading, tools, keyword_value, tool}=this.state;

        return(
            <Container fluid>
                <Row>
                    <Col xs={12}>
                        <h4 className="header-title m-t-0 m-b-20">Tools!</h4>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-left">
                        <Link to={Route.toUrl("dashboard_tool_add")}
                              className="section_link_add_dashboard"><i className="fa fa-plus" /> Add
                        </Link>
                    </Col>
                </Row>


                <hr className="dashboard_my_hr"/>
                {
                    loading ? <Container><Row><Col className="text-center"><Loading isLoading={loading} icon="loadDashboardInfo"/></Col></Row></Container> :
                    <Fragment>
                            <Row>
                                <Col className="col-xs-10 col-xs-offset-1 col-sm-10 col-sm-offset-1">
                                    <Row>
                                        <form onSubmit={this.search}>
                                            <Col className="col-xs-12 col-sm-12 dashboard_tools_search">
                                                <Col className="col-sm-10">
                                                    <input
                                                        type="text"
                                                        className="form-control homePage_select_search"
                                                        placeholder="Search here"
                                                        value={keyword_value}
                                                        onChange={this.handleChangeKeyword}
                                                    />
                                                </Col>
                                                <Col className="col-xs-2 col-sm-2 homePage_search_button">
                                                    <Button className="btn btn-warning">
                                                        <span className="glyphicon glyphicon-search"></span> Search
                                                    </Button>
                                                </Col>
                                            </Col>
                                        </form>
                                    </Row>
                                    {
                                        !tool ?
                                            <Row>
                                                <Col className="col-sm-12 dashboard_search_result">
                                                    No tool
                                                </Col>
                                            </Row>
                                            :
                                            tools.map((tool, i) => (
                                                <Row key={i} className="dashboard_tools_row ">
                                                    <Col  className="col-xs-2 col-sm-2 dashboard_images_list_block">
                                                        <img className="dashboard_tools_img" src={`${http.getDomain()}/${tool.t_image}`} alt=""/>
                                                    </Col>
                                                    <Col  className="col-xs-9 col-sm-9">
                                                        <div className="dashboard_tools_list_title">{tool.t_title}</div>
                                                        <div className="dashboard_tools_list_description">
                                                            {
                                                                tool.t_description.length > 250 ?
                                                                    tool.t_description.substr(0,250)+' ...'
                                                                    :
                                                                    tool.t_description
                                                            }
                                                        </div>
                                                    </Col>
                                                    <Col className="col-xs-1 col-sm-1 dashboard_tools_linst_edit_link">
                                                        <Link to={Route.toUrl('dashboard_tool_edit', {toolId: tool._id})}
                                                              className="section_link_edit_dashboard section_link_edit_about_dashboard">
                                                            <i className="fa fa-pencil"/>
                                                        </Link>
                                                    </Col>
                                                    <Col className="col-xs-12 col-sm-12 text-right dashboard_all_tool_active_block">
                                                        {
                                                            tool.t_active == true ?
                                                                <div className="dashboard_all_tools_active">Active</div>
                                                                :
                                                                <div className="dashboard_all_tools_inactive">Inactive</div>
                                                        }
                                                    </Col>
                                                </Row>
                                            ))
                                    }
                                </Col>
                            </Row>
                    </Fragment>
                }
            </Container>
        );

    }
}
